import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Onboarding from '../pages/Onboarding';
import UnitDetails from '../pages/UnitDetails';
import Layout from './layout/Layout';
import OuterLayout from './outerlayout/OuterLayout';
import ProtectedRoutes from './ProtectedRoutes';
import Signup from '../components/auth/signup/Signup';
import LoginPage from '../pages/Login';
import VisitsPage from '../pages/VisitsPage';
import LocationPage from '../pages/LocationPage';
import LocationDetail from '../components/locations/locationDetail/LocationDetail';
import Locker from '../components/locker/Locker';
import AppointmentDetailsPage from '../pages/AppointmentDetailsPage';
import Dashboard from '../pages/Dashboard';
import ForgotPassword from '../components/auth/forgotPassword/ForgotPassword';
import Staff from '../pages/Staff';
import AddProperty from '../components/locations/addProperty/AddProperty';
import ResetPassword from '../components/auth/reset-password/ResetPassword';
import ResetPasswordNotification from '../components/auth/resetPasswordNotification/ResetPasswordNotification';
// import ForgotPassword from '.../components/auth/resetPassword/ForgotPassword;
import Visitor from '../pages/Visitor';
import CreateVisitor from '../pages/CreateVisitor';
import CreateAppointment from '../pages/CreateAppointment';
import LocationsForAvailability from '../components/availability/locations/LocationsForAvailability';
import UnitsForAvailability from '../components/availability/units/UnitsByLocationId';
import AddAvailability from '../components/availability/add-availability/AddAvailability';
import LocationsForNewLocationAvailability from '../components/new-location-availability/locations/LocationsForNewLocationAvailability';
import UnitsForNewLocationAvailability from '../components/new-location-availability/units/UnitsByLocationId';
import AddNewLocationAvailability from '../components/new-location-availability/add-availability/AddNewLocationAvailability';
import NewLocationAvailabilityConfirm from '../components/new-location-availability/confirm/AvailabilityConfirm';
import AvailabilityConfirm from '../components/availability/confirm/AvailabilityConfirm';
import Metrics from '../pages/Metrics';
import PropertyReport from '../pages/PropertyReport';
import AppSettings from '../pages/AppSettings';
import Invite from '../pages/Invite';
import ChangePasswordPage from '../pages/ChangePassword';
import ProfilePage from '../pages/Profile';
import Amenities from '../pages/Amenities';
import AddAmenities from '../pages/AddAmenities';
import UserManagement from '../pages/UserManagement';
import UserManagementPage from '../pages/UserManagement';
import UserManagementDetailPage from '../pages/UserManagementDetailPage';
import MappedIn from '../components/mappit/mappedIn';
import RolesListing from '../pages/RolesListing';
import RoleAndPermission from '../pages/RolePermission';
import StaffManagementPage from '../pages/StaffManagement';
import ForbiddenPage from '../pages/ForbiddenPage';
import AddPropertyForm from '../components/locations/addPropertyForm/AddPropertyForm';
import VendorAppointmentPage from '../pages/VendorAppointment';
import KeyDropPickUpPage from '../pages/KeyDropPickUp';
import SupportTicket from '../pages/SupportTicket';
import SupportTicketDetailPage from '../components/supportTicket/supportTicketDetail/SupportTicketDetail';

import ConciergePage from '../pages/Concierge';
import PynwheelConnect from '../components/pynwheelConnect/PynwheelConnect';

const RootRedirect = () => {
    const token = localStorage.getItem('adminAccessToken');
    return <Navigate to={token ? '/locations' : '/login'} replace />;
};

const Templete = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<RootRedirect />} />
                <Route element={<ProtectedRoutes />}>
                    <Route element={<Layout />}>
                        <Route index element={<LocationPage />} />
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="locations" element={<LocationPage />} />
                        <Route path="location/:id" element={<LocationDetail />} />
                        <Route path="unitdetails/:id" element={<UnitDetails />} />
                        <Route path="visits" element={<VisitsPage />} />
                        <Route path="staff" element={<Staff />} />
                        <Route path="appointment-details" element={<AppointmentDetailsPage />} />
                        <Route path="add-location" element={<AddProperty />} />
                        <Route path="edit-location/:id" element={<AddProperty />} />
                        {/* <Route path="/add-new-location" element={<AddPropertyForm />} />
                        <Route path="/edit-new-location/:id" element={<AddPropertyForm />} /> */}
                        <Route path="visitor" element={<Visitor />} />
                        <Route path="create-visitor" element={<CreateVisitor />} />
                        <Route path="create-appointment" element={<CreateAppointment />} />
                        <Route path="add-availability/locations" element={<LocationsForNewLocationAvailability />} />
                        <Route path="add-availability/units" element={<UnitsForNewLocationAvailability />} />
                        <Route path="add-availability/booking" element={<AddNewLocationAvailability />} />
                        <Route path="add-availability/confirm" element={<NewLocationAvailabilityConfirm />} />
                        <Route path="metrics" element={<Metrics />} />
                        <Route path="property-report" element={<PropertyReport />} />
                        <Route path="app-config" element={<AppSettings />} />
                        <Route path="invitation" element={<Invite />} />
                        <Route path="change-password" element={<ChangePasswordPage />} />
                        <Route path="profile" element={<ProfilePage />} />
                        <Route path="location/:id/mappedIn" element={<MappedIn />} />
                        <Route path="location/:id/pynwheel-connect" element={<PynwheelConnect />} />
                        <Route path="amenities" element={<Amenities />} />
                        <Route path="amenities/:id" element={<AddAmenities />} />
                        <Route path="user-management" element={<UserManagementPage />} />
                        <Route path="user-management/:id" element={<UserManagementDetailPage />} />
                        <Route path="role-listing" element={<RolesListing />} />
                        <Route path="vendor-appointments" element={<VendorAppointmentPage />} />
                        <Route path="key-pickup-drop" element={<KeyDropPickUpPage />} />
                        <Route path="all-scheduled-tours" element={<ConciergePage />} />
                        <Route path="role-permission/:id" element={<RoleAndPermission />} />
                        <Route path="staff-management" element={<StaffManagementPage />} />
                        <Route path="support-ticket" element={<SupportTicket />} />
                        <Route path="support/ticket-details/:id" element={<SupportTicketDetailPage />} />
                        <Route path="no-permission" element={<ForbiddenPage />} />
                    </Route>
                </Route>
                <Route element={<OuterLayout />}>
                    <Route path="login" element={<LoginPage />} />
                    <Route path="onboarding" element={<Onboarding />} />
                    <Route path="signup" element={<Signup />} />
                    {/* <Route path="/reset-password/:token" element={<ResetPassword />} /> */}
                    <Route path="forgot-password" element={<ForgotPassword />} />
                    {/* <Route path="/add-location" element={<AddLocation />} /> */}

                    <Route path="reset-password/:token" element={<ResetPassword />} />
                    <Route path="reset-password-notification" element={<ResetPasswordNotification />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default Templete;
